import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

interface IPopupProps {
  onClose: () => void
  onConfirm: () => void
}

const Popup = ({ onClose, onConfirm }: IPopupProps) => {
  const { text_primary_color } = useAppSelector(selectBranding)

  return (
    <div
      className="lk-toast-connection-state lk-toast lk-popup-content"
      style={{ maxWidth: '400px', textAlign: 'center' }}
    >
      <p style={{ color: `${text_primary_color}` }}>
        Запись встречи недоступна. <br /> Файловое хранилище заполнено на 100%. <br /> Расширьте
        тариф или удалите видеозаписи.
      </p>
      <div className="lk-popup-buttons">
        {/*<button className='lk-disconnect-button' style={{marginRight: '10px'}} onClick={() => redirect()}>Выход</button>*/}
        <button className="lk-button" onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>
  )
}

export default Popup
